/**
 * Simple/Advanced switching for a canonical Care Guide page.
 * Versions are reader modes, not duplicate pages. A #simple fragment is accepted so the
 * library's Simple action can progressively enhance to the same mode on the canonical page.
 */
(function(){
  'use strict';

  var root = document.querySelector('[data-bz-care-guide-page]');
  if (!root) return;

  var slug = root.getAttribute('data-care-slug') || '';
  var content = root.querySelector('[data-care-page-content]');
  var label = root.querySelector('[data-care-version-label]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-care-version-tab]'));
  var download = root.querySelector('[data-care-page-download]');
  var backLink = root.querySelector('[data-care-page-back]');

  function versionFromHash(){
    var hash = String(window.location.hash || '').toLowerCase();
    if (hash === '#simple') return 'simple';
    if (hash === '#advanced') return 'advanced';
    return '';
  }

  function syncVersionHash(version){
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.hash = version === 'simple' ? 'simple' : '';
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (_) {}
  }

  function hasSameSiteReferrer(){
    if (!document.referrer) return false;
    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch (_) {
      return false;
    }
  }

  function templateFor(version){
    return root.querySelector('[data-care-template][data-care-version="' + version + '"][data-care-slug="' + slug + '"]');
  }

  function showVersion(version){
    var template = templateFor(version);
    if (!template || !content) return;

    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));
    content.setAttribute('data-care-active-version', version);
    if (label) label.textContent = version === 'simple' ? 'Simple Care Guide' : 'Advanced Care Guide';

    tabs.forEach(function(tab){
      var active = tab.getAttribute('data-care-version-tab') === version;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
      if (active && content) content.setAttribute('aria-labelledby', tab.id);
    });
  }

  function tabForKey(tab, key){
    var index = tabs.indexOf(tab);
    if (index === -1) return null;
    if (key === 'Home') return tabs[0];
    if (key === 'End') return tabs[tabs.length - 1];
    if (key === 'ArrowLeft' || key === 'ArrowUp') return tabs[(index - 1 + tabs.length) % tabs.length];
    if (key === 'ArrowRight' || key === 'ArrowDown') return tabs[(index + 1) % tabs.length];
    return null;
  }

  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var version = tab.getAttribute('data-care-version-tab') || 'advanced';
      showVersion(version);
      syncVersionHash(version);
    });
    tab.addEventListener('keydown', function(event){
      var nextTab = tabForKey(tab, event.key);
      if (!nextTab) return;
      event.preventDefault();
      var version = nextTab.getAttribute('data-care-version-tab') || 'advanced';
      showVersion(version);
      syncVersionHash(version);
      nextTab.focus();
    });
  });

  var linkedVersion = versionFromHash();
  if (linkedVersion) showVersion(linkedVersion);

  if (backLink) {
    backLink.addEventListener('click', function(event){
      // Preserve native new-tab / copy-link behavior. A normal click returns to the
      // exact same-site history entry (including hub filters, search and scroll). If
      // this guide was opened directly, the real href remains the Care Guides fallback.
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!hasSameSiteReferrer() || window.history.length <= 1) return;
      event.preventDefault();
      window.history.back();
    });
  }

  if (download) {
    download.addEventListener('click', function(){
      if (!window.BZCareGuidePdf) return;
      window.BZCareGuidePdf.download({
        root: root,
        slug: slug,
        meta: {
          title: root.getAttribute('data-care-title') || 'Care Guide',
          species: root.getAttribute('data-care-species') || ''
        }
      });
    });
  }
})();
